module.exports = __webpack_public_path__ + "static/icon_freiraum-dc58be62d689423f1180d31987b69551.png";